import * as React from 'react';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { PBase, } from './components';
export var pDefaultTopModelsObject = {
    PBase: (React.createElement(TopModel, { name: "PBase" }, PBase)),
};
